import getConfig from "next/config";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

// These provide a default, but shall be overridden in EVERY page
const DEFAULT = {
  title: "飛天奶茶創作者事務所",
  description:
    "飛天奶茶整合來自世界各地的專業創作者，擔當企業與創作者之間溝通的橋樑，致力於為各界企業量身訂製最佳的多元化創意內容，可用於品牌推廣、商品宣傳、產品包裝、遊戲製作等等。",
};

const baselineConfig = {
  title: DEFAULT.title,
  description: DEFAULT.description,
  canonical: `https://${
    publicRuntimeConfig?.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME ??
    serverRuntimeConfig?.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME ??
    process.env.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME
  }`,
  keywords: "飛天奶茶,廣告設計,動漫,動畫,繪師,商業委託,美術設計,文創",
  openGraph: {
    url: `https://${
      publicRuntimeConfig?.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME ??
      serverRuntimeConfig?.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME ??
      process.env.NEXT_PUBLIC_CANONICAL_DOMAIN_NAME
    }`,
    type: "website",
    site_name: "飛天奶茶",
    title: DEFAULT.title,
    description: DEFAULT.description,
    locale: "zh_HK",
    images: [
      {
        url: "/static/logo.png",
        width: 2375,
        height: 855,
        alt: "飛天奶茶創作者事務所",
        type: "image/png",
      },
    ],
  },
  additionalLinkTags: [
    {
      rel: "icon",
      href: "/favicon.gif",
      sizes: "32x32",
    },
  ],
};

const USE_BASELINE_SEO_DEFAULT =
  publicRuntimeConfig?.NEXT_PUBLIC_USE_BASELINE_SEO_DEFAULT ??
  serverRuntimeConfig?.NEXT_PUBLIC_USE_BASELINE_SEO_DEFAULT ??
  process.env.NEXT_PUBLIC_USE_BASELINE_SEO_DEFAULT;

const defaultConfig = USE_BASELINE_SEO_DEFAULT
  ? {
      ...baselineConfig,
      defaultTitle: "飛天奶茶創作者事務所",
      titleTemplate: "%s | 飛天奶茶創作者事務所",
    }
  : {};

export const SeoBaselineConfig = baselineConfig;
export const SeoDefaultConfig = defaultConfig;
